/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsGraphDto } from '../../models/submissions-graph-dto';

export interface FactorSubmissionsByFieldGet$Params {
  clientName?: string;
  date?: string;
  blockName?: string;
  layoutName?: string;
}

export function factorSubmissionsByFieldGet(http: HttpClient, rootUrl: string, params?: FactorSubmissionsByFieldGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
  const rb = new RequestBuilder(rootUrl, factorSubmissionsByFieldGet.PATH, 'get');
  if (params) {
    rb.query('clientName', params.clientName, {});
    rb.query('date', params.date, {});
    rb.query('blockName', params.blockName, {});
    rb.query('layoutName', params.layoutName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsGraphDto>>;
    })
  );
}

factorSubmissionsByFieldGet.PATH = '/Factor/submissions-by-field';
